
import { defineComponent } from 'vue';
import api from '@/api/api';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import ModalCrud from '@/components/ModalCrud.vue';
import { formsValidations } from '@/utils/formsValidations';
import { formatKm } from '@/utils/formatkm';

export default defineComponent({
	name: 'ManutencaoCarrosDetalhesView',
	components: {
		ModalCrud
	},
	data() {
		return {
			fab: false,
			idCarro: 0,
			origins: [],
			carro: {
				NUMEROCARRO: '',
				DESCRICAOCARRO: '',
				CODIGO_STATUS: '',
			},
			search: '',
			dataset: [],
			resume: {
				ultimoKm: null,
				dataUltimoKm: null,
				responsavelUltimoKm: null,
				ultimaManutencaoDescricao: null,
				dataUltimaManutencao: null,
				proximaKm: null,
				proximaData: null,
			},
			appliedFilters: {
				origens: [],
				idStatus: 'A',
				responsaveis: [],
				dataInicio: null,
				dataFim: null,
				kmInicial: null,
				kmFinal: null,
			},
			modals: {
				criarEditarLancamento: {
					isLoading: false,
					visible: false,
					title: ''
				},
				inativar: {
					isLoading: false,
					visible: false,
					idAlvo: 0,
				},
				filtrarLancamentos: {
					isLoading: false,
					visible: false,
					title: 'Filtrar',
				}
			},
			forms: {
				criarEditarLancamento: {
					data: {
						id: 0,
						idTipo: null,
						dataExecucao: '',
						kmAtual: null,
						proximaKm: null,
						proximaData: null,
						inativo: false,
						motivoInativacao: '',
						responsavelInativacao: '',
					},
					controls: {
						isValid: true,
					},
					datasets: {
						tipos: []
					}
				},
				inativar: {
					motivo: '',
				},
				filtrarLancamentos: {
					data: {
						origens: [],
						idStatus: 'A',
						responsaveis: [],
						dataInicio: null,
						dataFim: null,
						kmInicial: null,
						kmFinal: null,
					},
					inputs: {
						responsaveis: [],
						status: [
							{
								id: 'todos',
								label: 'Todos'
							},
							{
								id: 'A',
								label: 'Ativo'
							},
							{
								id: 'I',
								label: 'Inativo'
							},
						],
					}
				}
			},
		}
	},
	setup() {
		return {
			formsValidations,
			formatKm
		}
	},
	methods: {
		loadOrigins: async function () {
			try {
				const { data } = await api.get('/cars-maintenance-origins');
				this.origins = data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		iconFor: function (codigo) {
			return this.origins.find(x => x.codigo === codigo)?.icone ?? 'mdi-wrench';
		},
		loadDataGrid: async function () {
			try {
				const { origens, idStatus, responsaveis, dataInicio, dataFim, kmInicial, kmFinal } = this.appliedFilters;

				const response = await api.get('/cars-maintenance', {
					params: {
						idCarro: this.idCarro,
						origens,
						responsaveis,
						idStatus: idStatus === 'todos' ? null : idStatus,
						dataInicio,
						dataFim,
						kmInicial,
						kmFinal,
					}
				});

				this.dataset = response.data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		loadResume: async function () {
			try {
				const response = await api.get(`/cars-maintenance/resume/${this.idCarro}`);
				this.resume = response.data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		showModalNewEdit: async function (id) {
			try {
				this.modals.criarEditarLancamento.title = id ? 'Editar Lançamento' : 'Novo Lançamento';
				this.modals.criarEditarLancamento.visible = true;
				this.modals.criarEditarLancamento.isLoading = true;

				let codigoOrigem = 'M';
				let idTipoAtual = null;

				if (id) {
					const { data } = await api.get(`/cars-maintenance/${id}`);

					codigoOrigem = data.codigoOrigem;
					idTipoAtual = data.idTipo;

					this.forms.criarEditarLancamento.data = {
						id: data.id,
						idTipo: data.idTipo,
						dataExecucao: data.dataExecucao,
						kmAtual: data.kmAtual,
						proximaKm: data.proximaKm,
						proximaData: data.proximaData,
						inativo: data.idStatus === 'I',
						motivoInativacao: data.motivoInativacao ?? '',
						responsavelInativacao: data.responsavelInativacao ?? '',
					};
				};

				const { data: tipos } = await api.get('/cars-maintenance/types-for-launch', {
					params: {
						origem: codigoOrigem === 'S' ? 'S' : 'M',
						idTipo: idTipoAtual
					}
				});

				this.forms.criarEditarLancamento.datasets.tipos = tipos;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		closeModal: function () {
			this.modals.criarEditarLancamento.visible = false;
			this.forms.criarEditarLancamento.data = {
				id: 0,
				idTipo: null,
				dataExecucao: '',
				kmAtual: null,
				proximaKm: null,
				proximaData: null,
				inativo: false,
				motivoInativacao: '',
				responsavelInativacao: '',
			};
		},
		saveLancamento: async function () {
			try {
				if (this.$refs.form.validate()) {
					this.modals.criarEditarLancamento.isLoading = true;

					const [metodo, mensagem] = this.forms.criarEditarLancamento.data.id ? ['put', 'alterado'] : ['post', 'criado'];
					await api[metodo]('/cars-maintenance', {
						...this.forms.criarEditarLancamento.data,
						idCarro: this.idCarro
					});

					this.$toast.success(`Lançamento ${mensagem} com sucesso!`);
					this.closeModal();
					await this.loadDataGrid();
					await this.loadResume();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditarLancamento.isLoading = false;
			}
		},
		abrirInativar: function (item) {
			this.modals.inativar.idAlvo = item.id;
			this.forms.inativar.motivo = '';
			this.modals.inativar.visible = true;
		},
		confirmarInativar: async function () {
			try {
				this.modals.inativar.isLoading = true;

				await api.patch(`/cars-maintenance/${this.modals.inativar.idAlvo}`, {
					idStatus: false,
					motivoInativacao: this.forms.inativar.motivo
				});

				this.$toast.success('Lançamento inativado com sucesso!');
				this.modals.inativar.visible = false;
				await this.loadDataGrid();
				await this.loadResume();
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.inativar.isLoading = false;
			}
		},
		reativar: async function (item) {
			try {
				await api.patch(`/cars-maintenance/${item.id}`, { idStatus: true });
				this.$toast.success('Lançamento reativado com sucesso!');
				await this.loadDataGrid();
				await this.loadResume();
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		abrirFiltro: async function () {
			try {
				this.modals.filtrarLancamentos.isLoading = true;
				this.forms.filtrarLancamentos.data = { ...this.appliedFilters };
				this.modals.filtrarLancamentos.visible = true;

				const { data } = await api.get(`/cars-maintenance/filter-responsibles/${this.idCarro}`);

				this.forms.filtrarLancamentos.inputs.responsaveis = data ?? [];
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.filtrarLancamentos.isLoading = false;
			}
		},
		aplicarFiltro: async function () {
			this.appliedFilters = { ...this.forms.filtrarLancamentos.data };
			this.modals.filtrarLancamentos.visible = false;

			await this.loadDataGrid();
		},
		xlsxExport: async function () {
			try {
				const { XlsxExport } = await import('@/utils/xlsxExport');

				const prepareData = this.filteredDataset.map(x => ({
					origem: x.origem,
					descricao: x.descricao,
					responsavel: x.responsavel,
					dataExecucao: x.dataExecucao,
					kmAtual: x.kmAtual ?? '',
					proximaData: x.proximaData ?? '',
					proximaKm: x.proximaKm ?? '',
					idStatus: x.idStatus === 'A' ? 'Ativo' : 'Inativo'
				}));

				let instanceExport = new XlsxExport({
					columns: [
						{ name: 'origem', label: 'Origem' },
						{ name: 'descricao', label: 'Serviço' },
						{ name: 'responsavel', label: 'Responsável' },
						{ name: 'dataExecucao', label: 'Data' },
						{ name: 'kmAtual', label: 'Km Atual' },
						{ name: 'proximaData', label: 'Próxima Data' },
						{ name: 'proximaKm', label: 'Próxima Km' },
						{ name: 'idStatus', label: 'Status' },
                        { name: 'observacao', label: 'Observação' },
					],
					data: prepareData,
					title: `Manutenções - ${this.carro.NUMEROCARRO} ${this.carro.DESCRICAOCARRO}`
				});

				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao exportar!');
			}
		},
	},
	computed: {
		isQuilometragem() {
			return this.forms.criarEditarLancamento.data.idTipo === 1;
		},
		isReadonly() {
			return this.forms.criarEditarLancamento.data.inativo;
		},
		tipoSelecionado() {
			return this.forms.criarEditarLancamento.datasets.tipos.find(
				t => t.id === this.forms.criarEditarLancamento.data.idTipo
			);
		},
		checkMobileScreen() {
			return this.isMobile;
		},
		filteredDataset() {
			const lowerSearch = this.search.toLowerCase();

			return this.dataset.filter(x =>
				x.descricao.toLowerCase().includes(lowerSearch) ||
				x.dataExecucao.toLowerCase().includes(lowerSearch) ||
				(x.observacao ?? '').toLowerCase().includes(lowerSearch)
			);
		}
	},
	async mounted() {
		this.idCarro = Number(this.$route.params.id);

		try {
			const { data: carro } = await api.get(`/cars/${this.idCarro}`);

			if (carro.CODIGO_STATUS !== 'A') {
				this.$toast.error('Esse carro está inativo!');
				this.$router.push('/cars-maintenance');
				return;
			};

			this.carro = carro;
		} catch (error) {
			this.$toast.error('Carro não encontrado!');
			this.$router.push('/cars-maintenance');
			return;
		};

		store.commit(M_MENU, `Manutenção - ${this.carro.NUMEROCARRO} ${this.carro.DESCRICAOCARRO}`);
		await this.loadOrigins();
		await this.loadResume();
		await this.loadDataGrid();
	}
})
